import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  pageSize: 24,

  fetchId: null,
  isFetching: false,
  isFetched: false,
  fetchError: null,
  totalCount: 0,
  items: [],

  highlighted: {
    stock: null,
    field: null,
  },

  filters: {
    txType: [],
    districts: [],
  },
  sorting: null,
  autoSearch: true,

  recentVisited: JSON.parse(localStorage.getItem('recentVisitedStocks') || '[]'),
  fetchedRecentVisited: [],
  favorite: JSON.parse(localStorage.getItem('favoriteStocks') || '[]'),
  favorite2: [],
  fetchedFavorite: [],
};

export default {
  namespaced: true,

  state,
  mutations,
  actions,
  getters,
};
